// import React from "react";
import Storage from "./storage.service";
import Settings from "./settings.service";
import Helpers from "../helpers/shared.helper";
import HTTP from "./http.service";
import Products from "./products.service";
import User from "./user.service";
import Numbers from "./numbers.service";
import Promotions from "./promotions.service";
import Summaries from "./summaries.service";
import Translations from "./translation.service";

import * as variables from '../variables';
import CONSTANTS from "./constants.service";
import { isArray } from "rxjs/internal-compatibility";
import Translation from "./translation.service";

var Plans = {};

var service_types = "1,3,4,10";

Plans.getCITC = () => {
    Storage.set("citcErrorStatus", true, true);
    const config = {
        method: "get",
        url: `cms/citc_plan_cards_list_by_type?type=plan`,
        headers: {
            "Virgin-Lang": Translation.getCurrentLanguage()
          }
    };
    return HTTP(config)
}


Plans.getPAYGPlans = available_plans => {
    let payg = {};
    for (let type of Settings.order) {
        if (available_plans[type]) {
            for (let plan of Object.keys(available_plans[type])) {
                if (available_plans[type][plan]["ChargingType"] === "PAYG") {
                    payg[type] = available_plans[type][plan];
                    break;
                }
            }
        }
    }
    return payg;
};


Plans.getSumData = (dataList, vairableType, dataType) => {
    let sumValues = 0;

    if (dataList?.length) {
        dataList.forEach((item) => {
            if (item.Type.toString() === vairableType.toString()) {
                if (dataType === "gb") {
                    sumValues = item.Value === -1 ? -1 : sumValues +
                        Helpers.bytesToGBs(item.Value)
                } else if (dataType === "min") {
                    sumValues = item.Value === -1 ? -1 : sumValues +
                        Helpers.milisecondstoMinutes(item.Value)
                }
            }
        })
    }
    return sumValues;
};

Plans.fetchAvailablePlans = () => {
    let product_codes = Storage.get("ActiveProductCodes");
    let offerAppliedPromoId = Storage.get("offer_applied_promotion_id", true)
    // product_codes = "6";
    let config = {
        method: "get",
        url:
            "/products/available_plans?product_codes=" +
            product_codes +
            "&service_types=" +
            service_types +
            "&include_Vanity_Plan=true" +
            "&include_optional_promotions=true",
        headers: {
            // "accept-version": "v18",
            "cache-control": "no-cache"
        }
    };
    if (offerAppliedPromoId?.length) {
        let promotionID = isArray(offerAppliedPromoId) ?
            offerAppliedPromoId.join(",") :
            offerAppliedPromoId;
        config = {
            method: "get",
            url: "/products/available_plans?product_codes=" +
                product_codes +
                "&service_types=" +
                service_types +
                "&include_Vanity_Plan=true" +
                "&include_optional_promotions=true" +
                "&promotion_codes=" + promotionID,
            headers: {
                // "accept-version": "v18",
                "cache-control": "no-cache"
            }
        };
    }
    return HTTP(config);
};

Plans.fetchPredefinedPlans = () => {
    // let product_codes = Storage.get("ActiveProductCodes");
    let product_codes = CONSTANTS.PC_DEFAULT_MONTH;
    let offerAppliedPromoId = Storage.get("offer_applied_promotion_id", true);
    let config = {
        method: "get",
        url: "/products/predefined_bundles?include_optional_promotions=true&product_codes=" + product_codes
    };

    if (offerAppliedPromoId?.length) {
        let promotionID = offerAppliedPromoId.join(",");
        // Storage.set("offer_applied_local", true, true);
        config = {
            method: "get",
            url: "/products/predefined_bundles?include_optional_promotions=1&product_codes=" + product_codes + "&promotion_codes=" + promotionID,
            headers: {
                // "accept-version": "v17",
                "cache-control": "no-cache"
            }
        };
    }
    console.log("config", config)
    return HTTP(config);
};

Plans.fetchDiscountedPredefinedPlans = (promotion_id) => {
    let product_codes = Object.keys(Storage.get("Products")).join(",");
    product_codes = Storage.get("selectedProduct");
    let config = {
        method: "get",
        url: "/products/predefined_bundles?include_optional_promotions=1&product_codes=" + product_codes + "&promotion_codes=" + promotion_id,
        headers: {
            // "accept-version": "v17",
            "cache-control": "no-cache"
        }
    };
    return HTTP(config);
};

Plans.getPromoObject = (plan) => {
    if (plan["Promotions"] && plan["Promotions"] !== null) {
        return plan["Promotions"];
    }
    if (plan["PlanPromotions"] && plan["PlanPromotions"] !== null) {
        return plan["PlanPromotions"];
    }
    if (plan["Promotion"] && plan["Promotion"] !== null) {
        return plan["Promotion"];
    }
    return null;
}

Plans.getlanPromotions = (plan) => {
    if (plan["PlanPromotions"] && plan["PlanPromotions"] !== null) {
        return plan["PlanPromotions"];
    }
    return null
}

Plans.getPlanDataValue = (plan, type, dataValue = true) => {
    let value = "";
    if (plan?.length) {
        plan.forEach((data) => {
            if (data?.Type === type) {
                if (dataValue) {
                    value = data?.Value !== -1
                        ? Helpers.bytesToGBs(data?.Value)
                        : 0;
                } else {
                    value = data?.PlanID.toString();
                }

            }

        })
    }
    return value;

}
Plans.calculatePriceforAvailablePlan = () => {
    let planSpecs = Storage.get("SelectedAvailablePlan");

    let plan = {};

    let pricing = Storage.get("pricingByProduct")[
        "" + Storage.get("selectedProduct")
    ];
    //@Todo
    if (planSpecs) {
        let price = {
            withVat: 0,
            noVat: 0,
            monthlyPlanPriceWithVat: 0,
            monthlyPlanPriceNoVat: 0,
        };

        let subs = [];

        for (let type of Object.keys(planSpecs)) {
            let subplan = planSpecs[type];
            subs.push(subplan.ID);

            price["withVat"] += subplan["Price"];
            price["noVat"] += subplan["PriceVATExc"];
        }

        let lookup = subs.sort().join(",");

        let vat_percentage = JSON.parse(Storage.get("business", true))[
            "vat_percentage"
        ];

        if (pricing[lookup]) {
            plan = pricing[lookup];
            plan = Plans.getSinglePlanWithSpecs(pricing[lookup]);
            plan["specs"] = planSpecs;

            // Fetch monthly plan Price from PackagesPricingTable
            plan["monthlyPlanPriceNoVat"] = plan["MonthlyNetCost"];
            plan["monthlyPlanPriceWithVat"] = (plan["MonthlyNetCost"] * ((100 + vat_percentage) / 100)).toFixed(2);

            // Fetch plan Price from PackagesPricingTable
            plan["noVat"] = plan["Price"];
            plan["withVat"] = (plan["Price"] * ((100 + vat_percentage) / 100)).toFixed(2);

            // Total Plan Price
            price["withVat"] = plan["withVat"];
            price["noVat"] = plan["noVat"]

            // Monthly Plan Price
            price["monthlyPlanPriceWithVat"] = plan["monthlyPlanPriceWithVat"];
            price["monthlyPlanPriceNoVat"] = plan["monthlyPlanPriceNoVat"]

        } else {
            plan = {
                DiscountedPriceVATExc: price["noVat"],
                Plans: subs,
                Price: price["noVat"],
                Promotions: null,
                lookup: lookup
            };
        }

        Storage.set("AvailablePlanObj", plan);
        Storage.set("AvailablePlanPrice", price);
        console.log("AvailablePlanObj", plan)
        console.log("AvailablePlanPrice", price)
    } else {
        Storage.set("AvailablePlanObj", null);
        Storage.set("AvailablePlanPrice", null);
    }
};

Plans.saveBundleFromParams = (product_code, plan_ids, streamingPromotionCode = null) => {

    //younis
    //Products.saveProduct
    //Plans.savePlan
    //Plans.getSelectedBundle


    // return Products.saveProduct()
    //     .then(response => {
    //         return Plans.savePlan(plan_ids, streamingPromotionCode)
    //             .then(result => {
    //                 Plans.getSelectedBundle()
    //             })
    //     })

    return new Promise(async (resolve) => {
        const response = await Products.saveProduct(product_code);
        if (response) {
            const result = await Plans.savePlan(plan_ids, streamingPromotionCode);
            if (result) {
                setTimeout(() => {
                    User.fetchFlowStatus().then(() => {
                        resolve(true)
                    }).catch(() => {
                        resolve(false)
                    })
                }, 2000);
            } else {
                resolve(false)
            }
        } else {
            resolve(false)
        }
    })

    // console.log('bundle_id==', bundle_id)
    // console.log('Storage==', Storage)
    // Plans.getPlans("Available");

    // Storage.get_obsrv("AvailablePlans").subscribe(data => {
    //  if (data) {
    //      Plans.getPlans("Predefined");
    //  }
    // });

    // Storage.get_obsrv("PredefinedPlans").subscribe(data => {
    //  console.log('PredefinedPlans data===>', data)
    //  if (data) {
    //      let bundle = data[bundle_id];
    //      if (bundle && !Storage.get('calling_saveProductAndBundle')) {
    //          alert('999')
    //          let f = Plans.saveProductAndBundle(bundle);
    //          Storage.set('calling_saveProductAndBundle', f);

    //          f
    //              .then(response => {
    //                  Summaries.init('storage_params["bundle_id"]');
    //                  User.fetchFlowStatus(11);
    //              })
    //              .catch(error => {
    //                  // Errors.redirectAfterError();
    //              });
    //      } else {
    //          // Errors.redirectAfterError();
    //      }
    //  }
    // });


};

Plans.savePlanFromParams = (plan_ids, streamingPromotionCode = null) => {
    return Plans.getProducts()
        .then(response => {
            Storage.set("selectedPlanSpecsIDs", plan_ids);
            Storage.set("promotionCodes", streamingPromotionCode);
            return Plans.saveProductAndCustomPlan()
                .then(response => {
                    Summaries.init('storage_params["plan_ids"]');
                    const streamData = Storage.get("StreamModal");
                    // console.log(streamData)
                    if (streamData?.TYPE === "STORAGE_PARAMS_CUS" ||
                        streamData?.TYPE === "STORAGE_PARAMS_PRD_PLAN_IDs") {
                        Storage.set("StreamModal", {});
                        return;
                    }
                    User.fetchFlowStatus(10);

                })
                .catch(error => {
                    // Errors.redirectAfterError();
                });
        })
        .catch(error => {
            // Errors.redirectAfterError();
        });
};

Plans.getProducts = () => {
    return Storage.getOrfetch("Products", Products.fetchAllProducts) // fetchProducts //fetchAllProducts
        .then(response => {
            if (response) {

                if (response.data && response.data["list_product"]) {
                    // 2. process products
                    Storage.set(
                        "Products",
                        Products.processProducts(response.data["list_product"])
                    );

                    Storage.set(
                        "ALLProductCodes",
                        JSON.stringify(Products.processProducts(response.data["list_product"]))
                    );

                    // Storage.set(
                    //     "selectedProduct",
                    //     response.data["list_product"][0]["ProductCode"]
                    // );

                    let esimPLan = JSON.parse(Storage.get("esimplan", true));
                    Products.getCurrentProduct().then((data) => {
                        if (data && data?.data) {
                            if (data?.data?.product) {
                                Storage.set("selectedProduct", data.data.product.ProductCode);
                            } else {
                                Storage.set("selectedProduct", CONSTANTS.PC_DEFAULT_MONTH);
                            }
                        }
                        if (esimPLan) {
                            Storage.set("selectedProduct", CONSTANTS.PC_ESIM_SIX_MONTHS_PLUS_PLAN);
                        }
                    });

                    // Products.getCurrentProduct().then((data) => {
                    //     if (data && data.data) {
                    //         if (data.data.product) {
                    //             Storage.set("selectedProduct", data.data.product.ProductCode);
                    //         } else {
                    //             Storage.set("selectedProduct", CONSTANTS.PC_DEFAULT_MONTH);
                    //         }
                    //     }
                    // });
                }
            }
        })
        .catch(error => { });
};

Plans.getActiveProductCode = async () => {
    return Storage.getOrfetch("ActiveProductCodes", Products.fetchAllActiveProductsCode) // fetchProducts //fetchAllProducts
        .then(response => {
            if (response) {
                if (response?.data?.ListProduct) {
                    let activeProdouctCode = [];
                    for (let product of response.data.ListProduct) {
                        activeProdouctCode.push(product.ProductCode)
                    }
                    Storage.set("ActiveProductCodes", activeProdouctCode.join(), true);
                    Storage.set("ActiveProductCodes", activeProdouctCode.join());
                }
            }
        })
        .catch(error => { });
}
Plans.findPlanType = (PredefinedPlans, plan) => {
    let ids = [];

    // 1. get predefined plans ids
    let bundles_keys = Object.keys(PredefinedPlans);
    for (let bundle_key of bundles_keys) {
        let combination = Plans.getPlanIDs(PredefinedPlans[bundle_key]);
        ids.push(combination);
    }

    // 2. get plan ids
    let plan_combination = Plans.getPlanIDs(plan);

    // 3. compare
    if (ids.indexOf(plan_combination) !== -1) {
        return "PRD";
    } else {
        return "CUS";
    }
};

Plans.getPlans = (type, forceFetch = false) => {
    return Plans.getActiveProductCode().then(response => {
        return Plans.getProducts()
            .then(response => {
                // 3. get plans
                return Storage.getOrfetch(
                    type + "Plans",
                    Plans["fetch" + type + "Plans"],
                    forceFetch
                    // true
                )
                    .then(response => {
                        // 3. process plans
                        // if (!Storage.get("AvailablePlans")) {
                        // Plans.getActiveProductCode();
                        if (type === "Available" && response?.data) {
                            Storage.set(
                                "AvailablePlanData",
                                JSON.stringify(response.data),
                                true
                            );
                        }
                        Plans["process" + type + "Plans"](response.data);

                        // }
                    })
                    .catch(error => { });
            })
            .catch(error => { });
    })
        .catch(error => { });
    // 1. get products
};

Plans.getPlansApiCall = (type) => {
    return Plans.getProducts()
        .then(response => {
            if (type === "Available") {
                return Plans.fetchAvailablePlans()
                    .then(response => {
                        Storage.set(
                            "newAvailablePlanData",
                            JSON.stringify(response.data),
                            true
                        );
                        Plans["process" + type + "Plans"](response.data);
                    })
                    .catch(error => { });
            } else {
                return Plans.fetchPredefinedPlans()
                    .then(response => {
                        Storage.set(
                            "PredefinedPlanData",
                            JSON.stringify(response.data["PreDefinedBundles"][0]["PreDefinedBundle"]),
                            true
                        );
                        Plans["process" + type + "Plans"](response.data);

                    })
                    .catch(error => { });
            }
        })
        .catch(error => { });
};

Plans.getPlansForStream = (type) => {
    return Plans.getProducts()
        .then(response => {
            // 3. get plans
            return Storage.getOrfetch(
                type + "Plans",
                Plans["fetch" + type + "Plans"]
                // true
            )
                .then(response => {
                    // console.log(response.data)
                    // 3. process plans
                    // if (!Storage.get("AvailablePlans")) {
                    // Storage.set("PackagesPricingTable",JSON.stringify(response.data?.AvailablePlansWithPackagesPricing[0]?.PackagesPricingTable))
                    Plans["process" + type + "Plans"](response.data);
                    // }
                })
                .catch(error => { });
        })
        .catch(error => { });

    // 1. get products
};

Plans.processAvailablePlans = (data, save = true) => {
    // let vat_factor = parseFloat(Globals.get("vat_factor"));
    // Storage.set("SelectedAvailablePlan", {});
    console.log("checkdata", data)
    const responseArray = Array.isArray(data.AvailablePlansWithPackagesPricing)
    if (!responseArray || (responseArray && !data.AvailablePlansWithPackagesPricing.length)) {
        throw new Error("array_not_exist_in_response");
    }
    let selected_months = Storage.get("selectedProduct") ? Storage.get("selectedProduct") : CONSTANTS.PC_DEFAULT_MONTH;
    let indexValue = data.AvailablePlansWithPackagesPricing.findIndex((ele) => ele?.ProductCode === selected_months)
    let pricingLookupArr = data.AvailablePlansWithPackagesPricing[indexValue].PackagesPricingTable.map(itm => {
        let item = itm;
        item["lookupID"] = itm.Plans.sort().join(",");
        return item;
    });

    let pricingLookupObj = Helpers.arrayToObject(pricingLookupArr, "lookupID");
    Storage.set("pricing", pricingLookupObj);

    let pricingByProduct = Storage.get("pricingByProduct");

    if (!pricingByProduct) {
        pricingByProduct = {};
    }

    pricingByProduct[Storage.get("selectedProduct")] = pricingLookupObj;

    Storage.set("pricingByProduct", pricingByProduct);
    Storage.set("PackagesPricingTable", data?.AvailablePlansWithPackagesPricing[indexValue]?.PackagesPricingTable)

    let customPlansByType = {};
    let plans = data.AvailablePlansWithPackagesPricing[indexValue]["AvailablePlans"].sort(Helpers.sortByPrice);
    let plan_types = [];

    for (let plan of plans) {
        let ID = plan.PlanID ? plan.PlanID : plan.ID;

        if (plan_types.indexOf(plan.Type) === -1) {
            plan_types.push(plan.Type);
            customPlansByType[plan.Type] = {};
        }

        if (plan.Unit === "bytes") {
            plan["Formatted"] = plan.Value < 0 ? 'Unlimited' : Helpers.bytesToGBs(plan.Value);
            plan["FormattedUnit"] = "GB";
            plan["FormattedUnitLokaliseKey"] = "general_plan_units_gb";

            plan["Extra"] = 0;
            if (plan["IsEligibleForDataDoubling"]) {
                plan["Extra"] += plan["Formatted"];
            }
        }

        if (plan.Unit === "milliseconds") {
            plan["Formatted"] = plan.Value < 0 ? 'Unlimited' : Helpers.milisecondstoMinutes(plan.Value);
            plan["FormattedUnit"] = "min";
            plan["FormattedUnitLokaliseKey"] = "general_plan_units_minute_short";
        }

        customPlansByType[plan.Type][ID] = plan;
    }

    Storage.set("plan_types", plan_types);

    let excluded = Settings.excluded_plan_types.split(",");
    let keys = {};

    for (let type of plan_types) {
        if (excluded.indexOf(type) === -1) {
            keys[type] = Object.keys(customPlansByType[type]);
            let count = keys[type].length;
            let active = Math.floor(count / 2);
            Plans.selectAvailableSpec(customPlansByType[type][keys[type][active]]);
        }
    }

    if (save) {
        Storage.set("AvailablePlans", customPlansByType);
    }

    return customPlansByType;
};

Plans.addVanityPlan = predefinedPlans => {
    let flags = Storage.get("flags");
    if (Plans.addingVanity) {
        return;
    }

    Plans.addingVanity = true;
    let sub1 = null;
    let sub2 = null;

    let plans = { ...predefinedPlans };

    sub1 = Storage.get_obsrv("AvailablePlans").subscribe(AvailablePlans => {
        if (AvailablePlans) {
            let number = Storage.get("reserved_number");

            let vanity_detail = Numbers.getNumberDetailsFromVanity(number);
            if (Numbers.isPremiumNumber(number)) {
                vanity_detail["is_vanity_plan"] = true;
                let vanity_plan = Plans.getSinglePlanWithSpecs(vanity_detail);
                // let vanity_plan = "";
                if (vanity_plan) {
                    vanity_plan["PaygPlans"] = Plans.getPAYGPlans(AvailablePlans);
                    plans["vanity_plan"] = vanity_plan;
                    Plans.addingVanity = false;
                    Storage.set("PredefinedPlansWithVanity", plans);
                    if (sub1) sub1.unsubscribe();
                    if (sub2) sub2.unsubscribe();
                } else {
                    Plans.addingVanity = false;
                    Storage.set("PredefinedPlansWithVanity", plans);
                    if (sub1) sub1.unsubscribe();
                    if (sub2) sub2.unsubscribe();
                }
            } else {
                Plans.addingVanity = false;
                Storage.set("PredefinedPlansWithVanity", plans);
                if (sub1) sub1.unsubscribe();
                if (sub2) sub2.unsubscribe();
            }
        }
    });

    if (flags.NumberSelected) {
        sub2 = Storage.get_obsrv("reserved_number").subscribe(number => {
            if (number) {
                if (Numbers.isPremiumNumber(number)) {
                    // Plans.getPlans("Available");
                    if (!Storage.get("Available") && !Storage.get("Products")) {
                        Plans.getPlans("Available");
                    }
                } else {
                    Plans.addingVanity = false;
                    Storage.set("PredefinedPlansWithVanity", plans);
                    if (sub1) sub1.unsubscribe();
                    if (sub2) sub2.unsubscribe();
                }
            }
        });
    } else {
        Plans.addingVanity = false;
        Storage.set("PredefinedPlansWithVanity", plans);
        if (sub1) sub1.unsubscribe();
        if (sub2) sub2.unsubscribe();
    }
};

Plans.processPredefinedPlans = (data, save = true) => {
    let plans = data["PreDefinedBundles"][0]["PreDefinedBundle"];
    // console.log(plans)
    Plans.getPlanWithSpecs(plans);

    let plansLength = plans.length
    let heroPlanIds = [];
    for (let i = 0; i < plansLength; i++) {
        if (plans[i].Name === 'Hero') {
            heroPlanIds = [plans[i].Plan[0].PlanID, plans[i].Plan[1].PlanID]
            Storage.set('heroPlanIds', heroPlanIds);
            break;
        }
    }
    if (save) {
        Storage.set("PredefinedPlans", plans);
    }

    return plans;
};

Plans.selectAvailableSpec = item => {
    console.log("selected spec", item)
    let selectedPlan = { ...Storage.get("SelectedAvailablePlan") };
    // console.log(selectedPlan)
    selectedPlan[item.Type] = item;
    Storage.set("SelectedAvailablePlan", selectedPlan);
    console.log("selectedPlan", selectedPlan)
    Storage.set("SelectedAvaialblePromotion",)
    Plans.calculatePriceforAvailablePlan();
};


Plans.processUserSelectionFromStorageParams = (storage_params, planData) => {
    Storage.set("wp_loader", true);
    let planIds = storage_params["plan_ids"];
    let bundleId = storage_params["bundle_id"];
    let productCode = storage_params["product_code"];

    if (planData?.length) {
        planData.forEach((ele) => {
            if (Number(ele?.ProductCode) === Number(productCode)) {
                Storage.set(
                    "FgPredefinedPlanData",
                    JSON.stringify(ele.PreDefinedBundle),
                    true
                );
                // Storage.set("FgPredefinedPlanData", response.data.PreDefinedBundles, true);
                Storage.set("selectedProduct", productCode, true);
                if (ele.PreDefinedBundle?.length) {
                    for (let plan of ele.PreDefinedBundle) {
                        console.log("planplan", plan)
                        if (Number(plan.ID) === Number(bundleId)) {
                            let data = {
                                plan_ids: planIds,
                                product_code: productCode,
                                promotion_codes: ""
                            }
                            Storage.set(
                                "selectedPlanData",
                                JSON.stringify(plan),
                                true
                            );
                            Storage.set("is_web_category_selected", true, true);
                            Storage.set("choose_plan_category", true, true);
                            Storage.set("is_predefined_selected", true, true);
                            Storage.set("plan_type", storage_params["plan_type"], true);

                            let sixAvailablePromotions = Plans.checkContentServices(plan.Promotions);
                            if (sixAvailablePromotions?.length) {
                                Storage.set("StreamModal",
                                    {
                                        'SHOW': true,
                                        'TYPE': "STORAGE_PARAMS_PRD_BUNDLE",
                                        'Plan_type': "WP_PLAN",
                                        'PLAN': data,
                                        'content_list': sixAvailablePromotions
                                    });
                            } else {

                                Plans.saveBundleFromParams(productCode, planIds)
                                    .then(response => {
                                        User.fetchFlowStatus(4).then(res => {
                                            Storage.set("wp_loader", false);
                                        }).catch(res => {
                                            Storage.set("wp_loader", false);
                                        })
                                    }).catch(res => {
                                        Storage.set("wp_loader", false);
                                    })

                            }
                        }
                    }

                }

            }
        })
    } else {
        Storage.set("wp_loader", false);
    }

}



Plans.getPlanWithSpecs = plans => {
    let plan_with_specs = {};
    for (let plan of plans) {
        let ID = plan.PlanID ? plan.PlanID : plan.ID;
        // if (!ID) {
        //  ID = "vanity_plan";
        // }\
        if (plan.Name !== "Social") {
            plan_with_specs[ID] = Plans.getSinglePlanWithSpecs(plan);
        }
    }
    return plan_with_specs;
};

Plans.getCustomPlanWithSpecs = plans => {
    let plan_with_specs = {};
    for (let index in plans) {
        let plan = plans[index];
        let ID = plan.PlanID ? plan.PlanID : plan.ID;
        if (plan.Name !== "Social") {
            plan_with_specs[ID] = Plans.getSinglePlanWithSpecs(plan);
        }
    }
    return plan_with_specs;
};

Plans.getCustomPlanPromotions = (plan, packagePricingTable, plan_ids = false) => {
    let lookupIds = [];
    let lookupIdsString = "";
    if (!plan_ids) {
        for (let item in plan) {
            lookupIds.push(plan[item].PlanID ? plan[item].PlanID : plan[item].ID);
            lookupIdsString = lookupIds.sort().join(",");
        }
    } else {
        lookupIdsString = plan_ids.split(",").sort().join(",");
    }

    // for (let item in packagePricingTable) {
    //     if (packagePricingTable[item].lookupID === lookupIdsString) {
    //         return packagePricingTable[item].Promotions;
    //     }
    // }

    const lookupArr = lookupIdsString.split(',').map(Number);

    for (let item in packagePricingTable) {
        if (
            (packagePricingTable[item].lookupID === lookupIdsString) ||
            (JSON.stringify(packagePricingTable[item]["Plans"].sort()) === JSON.stringify(lookupArr.sort()))
        ) {
            return packagePricingTable[item].Promotions;
        }
    }

    return null;
}

Plans.checkCustomPlanIds = (packagePricingTable, plan_ids) => {
    let lookupIdsString = plan_ids.split(",").sort().join(",");
    const lookupArr = lookupIdsString.split(',').map(Number);

    for (let item in packagePricingTable) {
        if (
            (packagePricingTable[item].lookupID === lookupIdsString) ||
            (JSON.stringify(packagePricingTable[item]["Plans"].sort()) === JSON.stringify(lookupArr.sort()))
        ) {
            return true;
        }
    }

    return false;
}

Plans.getAnghamiAndStarzplayPromotions = (promotionList) => { // Not used because there was requirement to add 4 more Streaming providers (6 total)
    if (!promotionList || promotionList.length === 0) return null;
    if (!promotionList) return null;
    let anghamiPromotion = null;
    let starzPlayPromotion = null;
    for (let promotion in promotionList) {
        try {
            let valueObj = JSON.parse(promotionList[promotion].Value);
            if (valueObj.Type === 'ANGHAMI')
                anghamiPromotion = promotionList[promotion];
            if (valueObj.Type === 'STARZPLAY')
                starzPlayPromotion = promotionList[promotion];
        } catch (e) {
            // console.log("Cannot parse value object")
        }
    }
    if (anghamiPromotion || starzPlayPromotion) {
        return {
            [variables.ANGHAMI_PROMOTION]: anghamiPromotion,
            [variables.STARZPLAY_PROMOTION]: starzPlayPromotion
        }
    }

    return null;
}
Plans.checkContentServices = (promotionList) => {
    const contnetService = Helpers.getStreaminService();
    let value = [];
    if (!promotionList || promotionList.length === 0) return value;
    if (!promotionList) return value;
    if (promotionList?.length) {
        promotionList.forEach((promotion) => {
            if (promotion?.Value) {
                let valueObj = typeof promotion?.Value === "string" ? JSON.parse(promotion?.Value) : promotion?.Value;
                promotion.Value = valueObj;
                if (valueObj?.Type && contnetService?.includes(valueObj?.Type?.toLowerCase())) {
                    value.push(promotion);
                }
            }

        })
    }
    return value;
}

Plans.getAvailableSixPromotions = (promotionList) => {
    if (!promotionList || promotionList.length === 0) return null;
    if (!promotionList) return null;

    let anghamiPromotion = null;
    let starzPlayPromotion = null;
    let osnPromotion = null;
    let ufcPromotion = null;
    let discoveryPromotion = null;
    let bluTvPromotion = null;

    for (let promotion in promotionList) {
        try {
            let valueObj = JSON.parse(promotionList[promotion].Value);
            if (valueObj.Type === 'ANGHAMI')
                anghamiPromotion = promotionList[promotion];
            if (valueObj.Type === 'STARZPLAY')
                starzPlayPromotion = promotionList[promotion];
            if (valueObj.Type === 'OSN')
                osnPromotion = promotionList[promotion];
            if (valueObj.Type === 'UFC')
                ufcPromotion = promotionList[promotion];
            if (valueObj.Type === 'Discovery')
                discoveryPromotion = promotionList[promotion];
            if (valueObj.Type === 'BluTV')
                bluTvPromotion = promotionList[promotion];
        } catch (e) {
            // console.log("Cannot parse value object")
        }
    }
    if (anghamiPromotion || starzPlayPromotion || osnPromotion || ufcPromotion || discoveryPromotion || bluTvPromotion) {
        // Store data of service provider in localStorage for display only in summary
        let promotionItems = {
            [variables.ANGHAMI_PROMOTION]: anghamiPromotion,
            [variables.STARZPLAY_PROMOTION]: starzPlayPromotion,
            [variables.OSN_PROMOTION]: osnPromotion,
            [variables.UFC_PROMOTION]: ufcPromotion,
            [variables.DISCOVERY_PROMOTION]: discoveryPromotion,
            [variables.BLUTV_PROMOTION]: bluTvPromotion,
        };

        //Filter empty or disbaled item from backend
        promotionItems = Object.values(promotionItems);
        promotionItems = promotionItems.filter(function (el) {
            return el != null;
        });

        //Store only required data
        let promoLocalItems = [];
        let len = promotionItems.length;
        for (let i = 0; i < len; i++) {
            let parsedValue = JSON.parse(promotionItems[i].Value);
            if (parsedValue != null) {
                promoLocalItems.push({
                    key: parsedValue.Type,
                    worth: parsedValue.Worth
                });
            }
        }
        Storage.set('streamingproviders', JSON.stringify(promoLocalItems), true);
        return {
            [variables.ANGHAMI_PROMOTION]: anghamiPromotion,
            [variables.STARZPLAY_PROMOTION]: starzPlayPromotion,
            [variables.OSN_PROMOTION]: osnPromotion,
            [variables.UFC_PROMOTION]: ufcPromotion,
            [variables.DISCOVERY_PROMOTION]: discoveryPromotion,
            [variables.BLUTV_PROMOTION]: bluTvPromotion,
        }
    }

    return null;
}

Plans.clear = () => {
    Storage.set("promotions", null);
    Storage.set("promotions_result", null);
};

Plans.getSinglePlanWithSpecs = plan => {
    let plan_specs = {};
    let plan_list = plan["Plan"] ? plan["Plan"] : plan["Plans"];
    let subplans = [];
    let result = false;
    // Updated plan_list.length with plan_list to handle Product Code: 6
    if (plan && plan_list?.length) {
        let test = JSON.stringify(plan_list);
        if (plan["promotions"]) {
            plan["offer_promotion"] = plan["promotions"];
        } else if (plan["Promotions"]) {
            plan["offer_promotion"] = plan["Promotions"];
        } else {
            plan["offer_promotion"] = null;
        }

        // console.log("offer promotion", plan["offer_promotion"], "plan : ", plan)
        if (test.indexOf('{') === -1) {
            // ids not objects

            let new_plan_list = [];
            let selected_months = Storage.get("selectedProduct") ? Storage.get("selectedProduct") : CONSTANTS.PC_DEFAULT_MONTH;
            let AvailablePlans = selected_months === 1 ? Storage.get('AvailablePlans') : Storage.get('AvailablePlansMonths');
            if (AvailablePlans) {
                for (let id of plan_list) {
                    for (let type of Settings.order) {

                        if (AvailablePlans[type]) {
                            let keys = Object.keys(AvailablePlans[type]);
                            if (keys.indexOf(id + '') !== -1) {
                                new_plan_list.push(AvailablePlans[type][id]);
                                break;
                            }
                        }
                    }
                }

                plan_list = new_plan_list;
            }

        }

        for (let plan_spec of plan_list) {
            if (isNaN(plan_spec)) {
                let ID = plan_spec.PlanID ? plan_spec.PlanID : plan_spec.ID;
                plan_spec["ID"] = ID;
                subplans.push(ID);
            }
        }
    }

    plan["lookupID"] = subplans.sort().join(",");

    let avail_plan = Storage.get("pricingByProduct")[
        Storage.get("selectedProduct")
    ][plan["lookupID"]];

    let promotions = [];

    if (avail_plan && !plan["is_vanity_plan"]) {

        let plan_promotions = Promotions.getPromotionsByPlan(avail_plan);

        let user_promotions = Storage.get("promotions");
        // console.log(plan)
        // console.log(plan_promotions, user_promotions)
        promotions = Promotions.combinePromotions(user_promotions, plan_promotions);
        // console.log(promotions)
        if (promotions) {
            result = Promotions.calculateAllPromotions(promotions, avail_plan);
            plan["Promotions"] = promotions;
            // console.log(result)
        }

        // if(result){
        //  plan['promos'] = [];
        // }
    }

    if (plan && plan_list?.length) {
        for (let plan_spec of plan_list) {
            if (plan_spec.Type === "DATA") {
                if (!plan["is_vanity_plan"]) {
                    plan_spec["Formatted"] = Helpers.bytesToGBs(plan_spec.Value);
                } else {
                    plan_spec["Formatted"] = plan_spec.Value;
                }

                plan["FormattedUnit"] = "GB";
                plan["FormattedUnitLokaliseKey"] = "general_plan_units_gb";
                let extra = 0;

                if (result && result.extraDataFormatted) {
                    extra = result.extraDataFormatted;
                }

                plan_spec["extra"] = extra;
                plan["extraDataFormatted"] = extra;
            }

            if (plan_spec.Type === "VOICE-LCL") {
                if (!plan["is_vanity_plan"]) {
                    plan_spec["Formatted"] = Helpers.milisecondstoMinutes(
                        plan_spec.Value
                    );
                } else {
                    plan_spec["Formatted"] = plan_spec.Value;
                }

                let extra = 0;

                if (result && result.extraLocalFormatted) {
                    extra = result.extraLocalFormatted;
                }

                plan_spec["extra"] = extra;
                plan["extraLocalFormatted"] = extra;

                plan["FormattedUnit"] = "min";
                plan["FormattedUnitLokaliseKey"] = "general_plan_units_minute_short";
            }

            if (plan_spec.Type === "VOICE-INT") {
                if (!plan["is_vanity_plan"]) {
                    plan_spec["Formatted"] = Helpers.milisecondstoMinutes(
                        plan_spec.Value
                    );
                } else {
                    plan_spec["Formatted"] = plan_spec.Value;
                }

                let extra = 0;

                if (result && result.extraInternationalFormatted) {
                    extra = result.extraInternationalFormatted;
                }

                plan_spec["extra"] = extra;
                plan["extraInternationalFormatted"] = extra;

                plan["FormattedUnit"] = "min";
                plan["FormattedUnitLokaliseKey"] = "general_plan_units_minute_short";
            }

            plan_specs[plan_spec.Type] = plan_spec;
        }

        plan["subplans"] = subplans.sort(Helpers.sortDefault);

        plan["specs"] = plan_specs;

        // plan['save_percentage'] = (promotions) && )

        //plan["OriginalPrice"] !== plan["DiscountedPrice"]? plan["DiscountedPrice"] / plan["OriginalPrice"] * 100: 0;

        if (plan["IsPopular"]) {
            Storage.set("popular_plan_id", plan["ID"]);
        }

    } else {
        plan = null;
    }

    return plan;
};

Plans.saveProductAndCustomPlan = () => {
    return Products.saveProduct()
        .then(response => {
            return Plans.savePlan();
        })
        .catch(error => { });
};

Plans.saveProductAndNoPlan = (streamingPromotionCode = null) => {
    Storage.set("promotionCodes", streamingPromotionCode);
    return Products.saveProduct()
        .then(response => {
            let payg_ids = JSON.parse(Storage.get("business", true))[
                "just_sim_plans_ids"
            ].join(",");
            return Plans.savePlan(payg_ids);
        })
        .catch(error => { });
};

Plans.isPAYG = data => {
    if (data && data.DATA && data["VOICE-LCL"])
        return data.DATA.Value === 0 && data["VOICE-LCL"].Value === 0;
    return false;
};

Plans.saveProductAndBundle = (bundle = null, streamingPromotionCode = null) => {

    if (Storage.get('calling_saveProductAndBundle')) {
        return Storage.get('calling_saveProductAndBundle');
    }

    if (bundle) {
        Storage.set("selectedPlanSpecsIDs", Plans.getPlanIDs(bundle));
        Storage.set("promotionCodes", streamingPromotionCode);
    } else {
        let selectedPlan = {
            specs: Storage.get("SelectedAvailablePlan")
        };
        Storage.set("selectedPlanSpecsIDs", Plans.getPlanIDs(selectedPlan));
        Storage.set("promotionCodes", streamingPromotionCode);
    }

    return Products.saveProduct()
        .then(response => {
            return Plans.savePlan()
                .then(resp => {
                    Plans.getSelectedBundle();
                })
                .catch(err => { });
        })
        .catch(error => { });
};
if (!Array.isArray) {
    Array.isArray = function (arg) {
        return Object.prototype.toString.call(arg) === "[object Array]";
    };
}
Plans.getPlanIDs = (selectedPlan, format = false) => {
    let plansListArray = [];
    let separator = format ? "|" : ",";

    let source = "specs";

    if (Array.isArray(selectedPlan) && selectedPlan.length === 0) {
        return "0" + separator + "0";
        // source = "PaygPlans";
    }

    let keys = Object.keys(selectedPlan[source]);
    let used = keys;

    if (format) {
        let ordered = Settings.order;
        used = ordered;
    }

    for (let subplanKey of used) {
        if (keys.indexOf(subplanKey) !== -1) {
            let subplan = selectedPlan[source][subplanKey];
            let ID = subplan.PlanID ? subplan.PlanID : subplan.ID;
            if (format) {
                plansListArray.push(subplan.Formatted);
            } else {
                plansListArray.push(ID);
            }
        }
    }

    return plansListArray.join(separator);
};

Plans.getCustomPlanIDs = (selectedPlan, format = false) => {
    let plansListArray = [];
    let separator = format ? "|" : ",";

    let ordered = Settings.order;
    let keys = Object.keys(selectedPlan);
    let used = keys;
    if (format) {
        used = ordered;
    }
    for (let type of used) {
        if (keys.indexOf(type) !== -1) {
            let subplan = selectedPlan[type];
            if (type === "DATA") {
                plansListArray.push(Helpers.bytesToGBs(subplan.Value));
            } else if (type === "VOICE-LCL" || type === "VOICE-INT") {
                plansListArray.push(Helpers.milisecondstoMinutes(subplan.Value));
            }
        }
    }

    return plansListArray.join(separator);
};

Plans.getSelectedBundle = () => {
    // Storage.set("should_select_plan", null, true)

    Storage.getOrfetch("selected_bundle", Plans.getSavedBundle, true)
        .then(response => {
            if (response.data) {
                // console.log(response.data)
                let selected_bundle = null;
                let saved = response.data.save_plans[0];
                // User.fetchFlowStatus(10);
                if (saved) {
                    selected_bundle = Plans.getSinglePlanWithSpecs(saved);
                    //@Todo? Get id of this combination if needed
                } else {
                    selected_bundle = null;
                }

                Storage.set("selected_bundle", selected_bundle);
            }
        })
        .catch(error => { });
};

Plans.getSavedBundle = (callee = "default") => {
    let offerAppliedPromoId = Storage.get("offer_applied_promotion_id", true);
    let config = {
        method: "get",
        url: "/plans/saved_plans",
        headers: {
            // "accept-version": "v18",
            "cache-control": "no-cache"
        }
    };

    if (offerAppliedPromoId?.length) {
        let promotionID = offerAppliedPromoId.join(",");
        config = {
            method: "get",
            // url: "/plans/saved_plans" + "?promotion_codes=" + promotionID,
            url: `/plans/saved_plans?promotion_codes=${promotionID}`,
            headers: {
                // "accept-version": "v18",
                "cache-control": "no-cache"
            }
        };
    }
    return HTTP(config);
};

Plans.savePlan = (plan_ids = null, promotion_codes = null) => {
    let offerAppliedPromoId = Storage.get("offer_applied_promotion_id", true);
    if (offerAppliedPromoId?.length) {
        let promotionID = offerAppliedPromoId.join(",");
        let storageId = Storage.get("promotionCodes")
        let config = {
            method: "post",
            url: "/plans/saved_plans",
            data: {
                is_5g: false,
                plan_ids: plan_ids?.plan_ids || Storage.get("selectedPlanSpecsIDs"),
                product_code: plan_ids?.product_code || Storage.get("selectedProduct"),
                promotion_codes: promotion_codes ? promotion_codes + "," + promotionID : storageId ? storageId + "," + promotionID : promotionID // 2_OSN3M 2_Discovery3M
            },
            headers: {
                // "accept-version": "v18",
                "cache-control": "no-cache"
            }
        };
        return HTTP(config);
    } else {
        let config = {
            method: "post",
            url: "/plans/saved_plans",
            data: {
                is_5g: false,
                plan_ids: plan_ids?.plan_ids || Storage.get("selectedPlanSpecsIDs"),
                product_code: plan_ids?.product_code || Storage.get("selectedProduct"),
                promotion_codes: promotion_codes ? promotion_codes : Storage.get("promotionCodes") // 2_OSN3M 2_Discovery3M
            },
            headers: {
                // "accept-version": "v18",
                "cache-control": "no-cache"
            }
        };
        return HTTP(config);
    }

};

Plans.renewPlan = (plan_ids = null, promotion_codes = null) => {

    let config = {
        method: "put",
        url: "/plans",
        data: {
            new_plan_ids: plan_ids ? plan_ids : Storage.get("selectedPlanSpecsIDs"),
            product_code: Storage.get("selectedProduct"),
            promotion_codes: promotion_codes ? promotion_codes : Storage.get("promotionCodes"),
            number: Storage.get("reserved_number")["MSISDN"]
        }
    };
    return HTTP(config);
};

Plans.postPlanExtras = (extras) => {
    let config = {
        method: "post",
        url: "/extras",
        data: {
            extras: extras ? JSON.stringify(extras) : JSON.stringify(Storage.get("extras"))
        }
    };
    return HTTP(config);
};

Plans.deletePlanExtra = (extras) => {
    let config = {
        method: "delete",
        url: "/extras/delete",
        data: {
            extras: extras ? JSON.stringify(extras) : JSON.stringify(Storage.get("extras"))
        }
    };
    return HTTP(config);
};

Plans.getPlanExtrasSummary = () => {
    let config = {
        method: "get",
        url: "/extras/summary",
    };
    return HTTP(config);
};

Plans.getPlanPromotionImage = (promotionImages, promotion_type, promotion_id) => {
    if (promotionImages) {
        return promotionImages[promotion_type + promotion_id + "_" + Translations.activeLang]
            && promotionImages[promotion_type + promotion_id + "_" + Translations.activeLang]["url"];
    }
}

//Return available promotion
Plans.getAvailablePromotions = (selectedService = false, promotions = []) => {
    if (selectedService) {
        if (selectedService === variables.PROMOTION_TYPE_ANGHAMI) {
            return promotions[variables.STARZPLAY_PROMOTION];
        } else if (selectedService === variables.PROMOTION_TYPE_STARZPLAY) {
            return promotions[variables.ANGHAMI_PROMOTION];
        }
    }

    return false;
}

Plans.getAllAvailablePromotions = (selectedServices = null, promotions) => {
    //Filter out empty or disabled promotions from backend
    promotions = promotions.filter(function (el) {
        return el != null;
    });
    let selectedServicesTypes = [];
    if (selectedServices) {
        for (let i = 0; i < selectedServices.length; i++) {
            selectedServicesTypes.push(selectedServices[i].Type);
        }
    }
    return promotions ? promotions.filter(el => !selectedServicesTypes.includes(JSON.parse(el.Value).Type)) : [];
    // return promotions && selectedServicesTypes.length > 0 ? promotions.filter(el => !selectedServicesTypes.includes(JSON.parse(el.Value).Type) ) : [];
}

Plans.savePlanWithPlanId = (data, streamingPromotionCode = null) => {
    return new Promise(async (resolve) => {
        const response = await Products.saveProduct(data?.product_code);
        if (response) {
            const result = await Plans.savePlan(data, streamingPromotionCode);
            if (result) {
                setTimeout(() => {
                    User.fetchFlowStatus().then(() => {
                        resolve(true)
                    }).catch(() => {
                        resolve(false)
                    })
                }, 2000);
            } else {
                resolve(false)
            }
        } else {
            resolve(false)
        }
    })
}

Plans.proccessVanityNumberDataKW = (vanitiLevel) => {
    let style = {};
    let theme = Storage.get("theme", true);
    let vanity_theme = Settings.get("vanity_theme");
    let theme_parsed = JSON.parse(theme);
    let vanity_details = Storage.get("vanity_details");
    let vanity_name = vanity_details[vanitiLevel]?.Name;
    let nameKey = Settings.get("vanity_name_number_kw") + vanity_name;
    let subnameKey = Settings.get("vanity_name_subname_kw") + vanity_name;
    // let name = Translations.keys[name_key];
    // let subname=Translations.keys[subname_key];
    let style_value = null;
    if (theme && vanity_theme && theme_parsed) {
        let style_value_comp = vanity_theme + vanity_name;
        if (style_value_comp) {
            style_value = theme_parsed[style_value_comp];
            style["color"] = style_value;
        }
    }
    return { nameKey, subnameKey, style_value };
};

export default Plans;